import { Buffer } from 'buffer';

export const REGISTRATION_TOKEN = 'sibill-registration-token';

interface RegistrationTokenData {
  source?: string;
  email: string;
  tax_number?: string;
}

export const parseRegistrationToken = (token: string): RegistrationTokenData | null => {
  if (!token) return null;
  const data = token.split('.')[1];
  if (!data) return null;

  const bodyStr = Buffer.from(data, 'base64').toString();
  const obj = JSON.parse(bodyStr);
  if ('sub' in obj) {
    return (obj as { sub: RegistrationTokenData }).sub;
  }

  return null;
};
